export const APP_VERSION = {
    name: 'PTCE',
    version: '1.2.1' // !! Penser à modifier la version dans index.html !!!
};
export const API_URL_DEV = 'http://ptce.localhost/back/api/';
// HOSTINGER
// export const api_url_prod = readable('https://collectifapi.yvanpoirier.fr/back/api/');
// OVH DNS
// export const api_url_prod = readable('http://knpnjql.cluster029.hosting.ovh.net/back/api/');
// OVH domaine
export const API_URL_PROD = 'https://www.info-ptce.fr/back/api/';
// TODO URL BACK
// export const API_URL_PROD = 'https://www.nyom.cc/back/api/';
export const REDIRECTION_REINIT = 'reinit';
export const REDIRECTION_CREATE = 'create';
export const ACTU_CATEGORY_PTCE = 1;
export const ACTU_CATEGORY_EVENEMENT = 2;
export const ACTU_CATEGORY_ACTUALITE = 3;
export const ACTU_CATEGORY_APPEL_A_PROJET = 4;
export const EVENT_PRESENTIAL = 2;
export const EVENT_DISTANCIAL = 3;
export const NEWSLETTER_SIMPLE = "newsletter_simple";
export const NEWSLETTER_CARTO = "newsletter_carto";
export const NEWSLETTER_PARTNER = "newsletter_partner";
